<template>
  <div class="content-warpper">
    <div class="warpper-title">
      <i class="iconfont iconbaoming"></i>
      学生管理
    </div>
    <div class="padding-sm">
      <div class="flex align-center justify-between margin-bottom-sm">
        <div class="flex align-center condition-warpper">
          <el-input
            v-model="stu_name"
            placeholder="请输入姓名"
            class="margin-right-sm"
          ></el-input>
          <el-input
            v-model="idcard"
            placeholder="请输入身份证号"
            class="margin-right-sm"
          ></el-input>
          <el-button type="primary" @click="onSearch">
            <p class="flex align-center font-size">
              <i class="el-icon-search margin-right-xs"></i>搜索
            </p>
          </el-button>
        </div>
        <div>
          
          <el-button type="primary" @click="dialog = true">
            <p class="flex align-center font-size">
              <i class="iconfont iconxinzeng margin-right-xs"></i>新增学生
            </p>
          </el-button>
        </div>
      </div>

      <div class="table-warpper">
        <el-table
          :data="studentList"
          header-row-class-name="table-header"
          row-class-name="table-row"
          alig="center"
          fit
          style="width: 100%"
        >
          <el-table-column width="70" type="index" align="center" label="序号">
          </el-table-column>
          <el-table-column label="姓名">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.stu_name }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="身份号">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.stu_idcard }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="性别">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.stu_sex === 1 ? "男" : "女" }}
              </div>
            </template>
          </el-table-column>

          <el-table-column label="年龄">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.stu_age }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="400">
            <template slot-scope="scope">
              <div class="table-operate">
                <el-button
                  size="medium"
                  type="primary"
                  @click="editItem(scope.row)"
                  >编辑
                </el-button>
                <el-button
                  size="medium"
                  type="danger"
                  @click="deleteItem(scope.row.stu_id)"
                  >删除
                </el-button>
                <router-link
                  :to="'/fuse/studentDetail?id=' + scope.row.stu_id"
                  class="margin-lr-xs"
                >
                  <el-button size="medium" type="primary"
                    >查看学习记录
                  </el-button>
                </router-link>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          v-if="studentList.length > 0"
          class="page-all"
          background
          :current-page.sync="page"
          :page-size="limit"
          layout="prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <student-dialog
      :setId="setId"
      :setItem="setItem"
      :dialog="dialog"
      @cancelDialog="cancelDialog"
    />
  </div>
</template>

<script>
import studentDialog from "@/views/fuse/page/dialog/studentDialog";
import { classStudentDel, classStudent } from "@/api/fuse";

export default {
  name: "student",
  components: { studentDialog },
  data () {
    return {
      id: '',
      stu_name: "",
      idcard: "",
      studentList: [],
      page: 1,
      total: 0,
      limit: 10,
      dialog: false,
      setId: 0,
      setItem: {}
    };
  },
  created () {
    this.$emit(
      "setIndex",
      '/fuse/class',
      "当前位置：班级管理 - 学生管理",
      true
    );
    this.id = this.$route.query.id
    if (this.$route.query.page) this.page = Number(this.$route.query.page), this.stu_name = this.$route.query.stu_name, this.idcard = this.$route.query.idcard
    this.getList()
  },
  methods: {
    async getList () {
      let _list = await classStudent(this.id, this.page, this.limit, this.stu_name, this.idcard,1)
      this.studentList = _list.data.list
      this.total = _list.data.count
    },
    editItem (obj) {
      this.setId = obj.stu_id
      this.setItem = obj
      this.dialog = true
    },
    deleteItem (id) {
      this.$confirm("确定要删除该学生吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "msg-btn",
        confirmButtonClass: "msg-btn",
        center: true
      }).then(() => {
        this.sureDelete(id);
      });
    },
    async sureDelete (id) {
      let _state = await classStudentDel(id);
      if (this.studentList.length === 1 && this.page > 1) {
        this.page--;
      }
      this.getList();
      this.$message.success(_state.msg);
    },
    cancelDialog (val) {
      if (val) {
        this.setId = 0;
        this.setItem = {};
        this.dialog = false;
        if (this.setId) {
          this.getList();
        } else {
          this.page = 1;
          this.getList();
        }
      } else {
        this.setId = 0;
        this.setItem = {};
        this.dialog = false;
      }
    },

    //  修改路径
    setPath () {
      this.$router.push({
        path: '/fuse/student',
        query: {
          id: this.$route.query.id,
          page: this.page,
          stu_name: this.stu_name,
          idcard: this.idcard,
        }
      })
    },
    onSearch () {
      if (this.page === 1) {
        this.setPath()
      } else {
        this.page = 1;
      }
    },
  },
  watch: {
    page () {
      this.setPath()
    },
    $route () {
      this.getList();
    }
  }
}
</script>

<style scoped lang="scss">
</style>